var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 24,
    viewBox: "0 0 17 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1120_67298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5583 24C3.91629 24 0.113159 20.2307 0.113159 15.6V8.4C0.113159 3.76928 3.91629 0 8.5583 0C12.6812 0 16.1871 2.94545 16.868 7.00063C16.9771 7.65517 16.5445 8.2721 15.89 8.38495C15.2354 8.49404 14.6223 8.05392 14.5094 7.39937C14.0204 4.50282 11.5527 2.4 8.60344 2.4C5.28557 2.4 2.61097 5.09342 2.61097 8.4V15.6C2.61097 18.9103 5.28557 21.6 8.60344 21.6C11.5489 21.6 14.0279 19.4972 14.5132 16.6006C14.6223 15.9461 15.2392 15.506 15.89 15.615C16.5445 15.7241 16.9658 16.3448 16.8567 16.9956C16.1834 21.0545 12.6774 24 8.5583 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.89119 13.0797C5.22912 13.0797 4.73633 12.5417 4.73633 11.8797V8.40757C4.73633 6.27089 6.45921 4.53296 8.60341 4.53296C10.0667 4.53296 11.3834 5.3455 12.0529 6.65459C12.3539 7.24518 12.1169 7.96744 11.5263 8.26838C10.9357 8.56932 10.2097 8.33609 9.90874 7.7455C9.65294 7.24142 9.11877 6.9292 8.56203 6.9292C7.74197 6.9292 7.04981 7.59127 7.04981 8.40381V11.8759C7.04605 12.5417 6.55326 13.0797 5.89119 13.0797Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1120_67298"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.7737,
    height: 24,
    fill: "white",
    transform: "translate(0.113159)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconc);
export default __webpack_public_path__ + "static/media/iconc.7547da087eee9c27e201f70ae28b904a.svg";
export { ForwardRef as ReactComponent };